import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@/types/general';
export const SoundCloud = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_8_4746)"><path d="M16.0312 5.25281C15.8199 5.25281 15.6121 5.27537 15.4126 5.31812C15.1454 2.61893 12.8619 0.502808 10.0938 0.502808C9.766 0.502808 9.5 0.768808 9.5 1.09656V10.5966C9.5 10.9243 9.766 11.1903 10.0938 11.1903H16.0312C17.6688 11.1903 19 9.85912 19 8.22156C19 6.58518 17.6688 5.25281 16.0312 5.25281Z" fill="currentColor" /><path d="M7.71875 1.69031C7.391 1.69031 7.125 1.95631 7.125 2.28406V10.5966C7.125 10.9243 7.391 11.1903 7.71875 11.1903C8.0465 11.1903 8.3125 10.9243 8.3125 10.5966V2.28406C8.3125 1.95631 8.0465 1.69031 7.71875 1.69031Z" fill="currentColor" /><path d="M5.34375 4.06531C5.016 4.06531 4.75 4.33131 4.75 4.65906V10.5966C4.75 10.9243 5.016 11.1903 5.34375 11.1903C5.6715 11.1903 5.9375 10.9243 5.9375 10.5966V4.65906C5.9375 4.33131 5.6715 4.06531 5.34375 4.06531Z" fill="currentColor" /><path d="M2.96875 4.06531C2.641 4.06531 2.375 4.33131 2.375 4.65906V10.5966C2.375 10.9243 2.641 11.1903 2.96875 11.1903C3.2965 11.1903 3.5625 10.9243 3.5625 10.5966V4.65906C3.5625 4.33131 3.2965 4.06531 2.96875 4.06531Z" fill="currentColor" /><path d="M0.59375 5.84656C0.266 5.84656 0 6.11256 0 6.44031V10.0028C0 10.3306 0.266 10.5966 0.59375 10.5966C0.9215 10.5966 1.1875 10.3306 1.1875 10.0028V6.44031C1.1875 6.11256 0.9215 5.84656 0.59375 5.84656Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_8_4746"><rect width="19" height="11.4" fill="white" transform="translate(0 0.502808)" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="19" height="12" viewBox="0 0 19 12" fill="currentColor" className={props.className}>{t0}{t1}</svg>;
    $[2] = props.className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};